import Workflow from '../../../components/Workflow';

export const IngestWorkflow = ({ style }) => {
  return (
    <div style={{ position: "relative", height: "100%", width: "100%", ...style }}>
      <Workflow />
    </div>
  );
};

export default IngestWorkflow;
